module.exports = __webpack_public_path__ + "media/images/empty_data-79cac8d9f5c87c61addcca266337b19e.png";